import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { change } from 'redux-form';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import ImageUploadComponent from '../../../Common/ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommonImageDisplay';

import messages from '../../../../locale/messages';

import { doRemoveEmailLogo } from '../../../../actions/siteadmin/manageLogo';
import { doUploadEmailLogo } from '../../../../actions/siteadmin/manageLogo';
import { photosShow } from '../../../../helpers/photosShow';
import { logouploadDir } from '../../../../config';
import { withQuery } from '../../../../hoc/withGraphql';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import s from './EmailLogoUploader.css';
import bt from '../../../../components/commonStyle.css';

class EmailLogoUploader extends React.Component {

  static propTypes = {
    doRemoveEmailLogo: PropTypes.any.isRequired,
    getLogoData: PropTypes.shape({
      loading: PropTypes.bool,
      getEmailLogo: PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    })
  };

  static defaultProps = {
    getLogoData: {
      loading: true
    },
  };

  success = async (file, fromServer) => {
    const { doUploadEmailLogo, getLogoData: { getEmailLogo }, change, demoRestriction } = this.props;
    let fileName, oldPicture, filePath;
    fileName = fromServer.file.filename;
    oldPicture = getEmailLogo != null ? getEmailLogo.value : null;
    filePath = fromServer.file.path;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    doUploadEmailLogo(fileName, filePath, oldPicture);
    await change('SiteSettingsForm', 'emailLogo', fileName);
  }

  deleteImage = async () => {
    const { doRemoveEmailLogo, getLogoData: { getEmailLogo }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await doRemoveEmailLogo(getEmailLogo?.value)
  }

  render() {
    const { getLogoData: { loading, getEmailLogo }, emailLogoLoader } = this.props;
    const { formatMessage } = this.props.intl;

    let path = photosShow(logouploadDir);

    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12} className={s.textAlignCenter}>
          <div className={bt.picContainerMain}>
            <div className={cx(bt.picContainer)}>
              <div className={bt.profilePic}>
                {
                  <CommonImageDisplay
                    loading={loading}
                    loader={emailLogoLoader}
                    image={path + getEmailLogo?.value}
                    isDefaultPic={getEmailLogo?.value ? false : true}
                    isDelete={true}
                    deleteImage={this.deleteImage}
                  />
                }
              </div>
            </div>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12} className={cx(s.space2, s.spaceTop2)}>
          <div className={cx(s.fullWidth, s.button, bt.btnPrimary, s.noPadding, 'photoUploadBtn')}>
            <ImageUploadComponent
              defaultMessage={formatMessage(messages.clickHeretoUploadLogo)}
              componentConfig={{
                iconFiletypes: ['.jpg', '.png', '.jpeg'],
                multiple: false,
                showFiletypeIcon: false,
                postUrl: '/uploadEmailLogo'
              }}
              loaderName={'emailLogoLoader'}
              success={this.success}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

const mapState = (state) => ({
  emailLogoLoader: state?.loader?.emailLogoLoader
});

const mapDispatch = {
  doRemoveEmailLogo,
  doUploadEmailLogo,
  change,
  demoRestriction
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withQuery(gql`
      query getEmailLogo{
        getEmailLogo {
          id
          title
          name
          value
          type
        }
      }
    `, {
    name: 'getLogoData',
    options: {
      ssr: false
    }
  }),
)(EmailLogoUploader);